import { Injectable } from '@angular/core';
import {
  EntityCollectionServiceBase,
  EntityCollectionServiceElementsFactory
} from '@ngrx/data';
import { TipoSubActividad } from './tipos-sub-actividad.model';

@Injectable({ providedIn: 'root' })
export class TipoSubActividadService extends EntityCollectionServiceBase<TipoSubActividad> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
    super('TipoSubActividad', serviceElementsFactory);
  }
}
